import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class User extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'user',
            id: this.props.Id,
            loading: true,
            lockScreen: 0,
            data:null,
            record: {
                id: 0,
                fname: '',
                lname: '',
                mobile: '',
                phone: '',
                email: '',
                nationalId: '',
                role: 3,
                isActive: true,
                password: ''
            }
        };
    }

    componentDidMount() { this.loadData(); }

    async loadData() {
        const currentId = this.getCurrentFormId();
        this.httpPost(`api/v1/${this.state.controllerName}/get`, { id: currentId })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) this.setState({ record: data.record, loading: false,data:data });
                else { this.showErorrMessage(data.message); this.setState({ loading: false }); }
            });
    }

    handleChange(field, value) {
        this.setState({ record: { ...this.state.record, [field]: value } });
    }

    async save(e) {
        e.preventDefault();
        this.setState({ lockScreen: 1 });
        this.httpPost(`api/v1/${this.state.controllerName}/save`, this.state.record)
            .then(data => {
                this.setState({ lockScreen: 0 });
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage('کاربر ذخیره شد');
                    this.setState({ redirect: '/users' });
                } else this.showErorrMessage(data.message);
            });
    }

    renderForm() {
        const { record } = this.state;
        const isEdit = record.id > 0;
        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">{isEdit ? `ویرایش ${record.fname} ${record.lname}` : 'کاربر جدید'}</h3>
                        </div>
                        <div className="nk-block-head-content">
                            <NavLink to="/users/" className="btn btn-dim btn-outline-light"><em className="icon ni ni-arrow-left"></em> بازگشت</NavLink>
                        </div>
                    </div>
                </div>

                <div className="nk-block">
                    <div className="card card-bordered">
                        <div className="card-inner">
                            <form onSubmit={e => this.save(e)}>
                                <div className="row g-4">
                                    <div className="col-md-6">
                                        <label className="form-label">نام <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" value={record.fname}
                                            onChange={e => this.handleChange('fname', e.target.value)} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">نام خانوادگی <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" value={record.lname}
                                            onChange={e => this.handleChange('lname', e.target.value)} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">موبایل</label>
                                        <input type="text" className="form-control" value={record.mobile}
                                            onChange={e => this.handleChange('mobile', e.target.value)} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">تلفن داخلی</label>
                                        <input type="text" className="form-control" value={record.phone}
                                            onChange={e => this.handleChange('phone', e.target.value)} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">ایمیل</label>
                                        <input type="email" className="form-control" value={record.email}
                                            onChange={e => this.handleChange('email', e.target.value)} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">کد ملی</label>
                                        <input type="text" className="form-control" value={record.nationalId}
                                            onChange={e => this.handleChange('nationalId', e.target.value)} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">نقش</label>
                                        <select className="form-select" value={record.role}
                                            onChange={e => this.handleChange('role', parseInt(e.target.value))}>
                                            <option value="1">مدیر</option>
                                            <option value="2">سرپرست</option>
                                            <option value="3">حسابدار</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">وضعیت</label>
                                        <select className="form-select" value={record.isActive ? '1' : '0'}
                                            onChange={e => this.handleChange('isActive', e.target.value === '1')}>
                                            <option value="1">فعال</option>
                                            <option value="0">غیرفعال</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">کلمه عبور {!isEdit && <span className="text-danger">*</span>}</label>
                                        <input type="password" className="form-control" value={record.password}
                                            onChange={e => this.handleChange('password', e.target.value)}
                                            placeholder={isEdit ? 'در صورت نیاز پر شود' : ''} />
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn btn-primary" disabled={this.state.lockScreen === 1}>
                                            <em className="icon ni ni-save"></em> ذخیره
                                        </button>
                                        <NavLink to="/users/" className="btn btn-dim btn-outline-light ms-2"><em className="icon ni ni-cross"></em> انصراف</NavLink>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            <Header data={this.state.data} />,
            <div className="nk-content"><div className="container-fluid"><div className="nk-content-inner">{this.renderForm()}</div></div></div>,
            <Footer />
        ];
        return contents;
    }
}